import { State, Country } from "country-state-city";
import { platform } from "../platform";
export const countryOptions = platform.isFarmer
  ? [{ value: "NG", label: "Nigeria" }]
  : Country.getAllCountries().map((country) => ({
      value: country.isoCode,
      label: country.name,
    }));

export const stateOptions = (country?: string) => {
  const states = State.getStatesOfCountry(country || "nigeria");
  return [
    { value: "all", label: "All State/Regions" },
    ...states.map((state) => ({
      value: state.isoCode,
      label: state.name,
    })),
  ];
};
